import type {
  NavSectionConfig,
  TenantFeatures,
} from "@/types/tenantFeatures";

/**
 * Full sidebar menu. Items with featureKey are removed when that flag is false.
 * (See getSidebarNavigation.)
 */
export const APP_NAVIGATION: NavSectionConfig[] = [
  {
    title: "Deals",
    items: [
      { label: "Summary", path: "/summary", iconKey: "trend" },
      { label: "My Dashboard", path: "/my-dashboard", iconKey: "clipboard" },
      { label: "My Tasks", path: "/my-tasks", iconKey: "myTasks" },
      { label: "Pipeline", path: "/", iconKey: "pipeline" },
      { label: "Create +", path: "/create", iconKey: "create" },
      { label: "AI Extractions", path: "/ai-extractions", iconKey: "aiExtractions" },
    ],
  },
  {
    title: "Relationships",
    items: [
      { label: "Sponsors", path: "/sponsors", iconKey: "sponsors" },
      { label: "NDAs", path: "/ndas", iconKey: "ndas" },
      { label: "Contacts", path: "/contacts", iconKey: "contacts" },
      { label: "Deal Sources", path: "/sources", iconKey: "sources" },
    ],
  },
  {
    title: "Real Estate",
    items: [
      {
        label: "Market Reports",
        path: "/market-reports",
        iconKey: "marketReports",
        featureKey: "market_reports",
        badge: "Beta",
      },
      { label: "Assets", path: "/assets", iconKey: "assets" },
      { label: "Tenants", path: "/tenants", iconKey: "tenants" },
    ],
  },
  {
    title: "Settings",
    items: [
      {
        label: "LLM Config",
        path: "/prompts",
        iconKey: "prompts",
        requiresPromptAdmin: true,
      },
      { label: "Templates", path: "/add-templates", iconKey: "templates" },
      { label: "Users", path: "/settings/users", iconKey: "users" },
    ],
  },
];

/** Returns only nav links allowed for this tenant and user. */
export function getSidebarNavigation(
  sections: NavSectionConfig[],
  features: TenantFeatures,
  showPromptAdmin: boolean,
): NavSectionConfig[] {
  const result: NavSectionConfig[] = [];

  for (const section of sections) {
    const visibleItems = [];

    for (const item of section.items) {
      if (item.featureKey && !features[item.featureKey]) {
        continue;
      }
      if (item.requiresPromptAdmin && !showPromptAdmin) {
        continue;
      }
      visibleItems.push(item);
    }

    if (visibleItems.length > 0) {
      result.push({ title: section.title, items: visibleItems });
    }
  }

  return result;
}
